module.exports = __webpack_public_path__ + "static/media/bicycle.9e97167a.svg";